export interface MockDemo {
  a: Function;
}

/** 门店编辑类型 */
export enum ShopEditType {
  /** 编辑 */
  Edit = 1,
  /** 签约（拓店任务页、机会点页，机会点签约转化门店） */
  Sign = 2,
  /** 创建（门店管理页） */
  Create = 3,
  /** 地图右键菜单创建（外部传入定位 */
  MapCreate = 4,
}

/**
 * 表单字段的默认配置参数，如 长度、单位
 */
export const editFieldDefaultConfig = {
  /** 门店编号 */
  number: {
    maxLength: '40'
  },
  /** 门店名称 */
  name: {
    maxLength: '30'
  },
  /** 门店地址 */
  address: {
    maxLength: '50'
  },
  /** 经纬度 */
  position: {
    maxLength: '30'
  },
  /** 免租期（天） */
  freeRentPeriod: {
    maxLength: '50'
  },
  /** 首年月租金 */
  firstYearMonthRent: {
    unit: '元'
  },
  /** 次年月租金 */
  secondYearMonthRent: {
    unit: '元'
  },
  /** 第三年月租金 */
  thirdYearMonthRent: {
    unit: '元'
  },
  /** 扣点值 */
  brokerage: {
    unit: '%',
    max: 100,
  },
  /** 递增描述 */
  desc: {
    maxLength: '300'
  },
  engineeringInfo: {
    maxLength: '300'
  },
  operationInfo: {
    maxLength: '300'
  },
  /** 门店照片 */
  picUrls: {
    maxCount: 5,
    size: 20,
    fileType: ['png', 'jpg', 'jpeg', 'gif', 'bmp']
  },
  /** 合同附件 */
  attachment: {
    maxCount: 1,
    fileType: ['doc', 'docx', 'pdf', 'xls', 'xlsx']
  },
  /** 闭店原因，和 src/views/expandstore/pages/shop/components/ChangeStatusModal.tsx 统一 */
  closeReason: { maxLength: '500' },
};

/** 图片字段 */
export const imagePropertyNames = [
  'picUrls',
];
